export function questionOptions(answers = []) {
  return answers.map((answer, index) => ({
    label: String(answer.label ?? ([answer.grade, answer.gradeDefinition]
      .filter(value => value !== null && value !== undefined && value !== "").join(": ") || `Opción ${index + 1}`)),
    value: String(answer.value ?? answer.grade ?? answer.id ?? index + 1),
  }));
}

export function optionValue(options, value) {
  const text = String(value ?? "");
  return options.find(option => option.value === text || option.label === text)?.value ?? text;
}

export function optionLabel(options, value) {
  const text = String(value ?? "");
  return options.find(option => option.value === text || option.label === text)?.label ?? text;
}
